import axios from "axios";
import { setAlert } from "./alert";
import {
  GET_PROFILE,
  PROFILE_ERROR,
  UPDATE_PROFILE,
  CLEAR_PROFILE,
  ACCOUNT_DELETED,
  GET_PROFILES,
  GET_REPOS,
} from "./types";

// Get current user profile
export const getCurrentProfile = () => async (dispatch) => {
  try {
    const res = await axios.get("/api/profile/me");
    dispatch({
      type: GET_PROFILE,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: PROFILE_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Get all user profiles
export const getProfiles = () => async (dispatch) => {
  dispatch({ type: CLEAR_PROFILE });
  try {
    const res = await axios.get("/api/profile");
    dispatch({
      type: GET_PROFILES,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: PROFILE_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Get all profiles by id
export const getProfileById = (userId) => async (dispatch) => {
  try {
    const res = await axios.get(`/api/profile/user/${userId}`);
    // console.log(res.data);
    dispatch({
      type: GET_PROFILE,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: PROFILE_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Get github repos
export const getGithubRepos = (username) => async (dispatch) => {
  try {
    const res = await axios.get(`/api/profile/github/${username}`);
    dispatch({
      type: GET_REPOS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: PROFILE_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Create or update profile
export const createProfile =
  (formData, history, edit = false) =>
    async (dispatch) => {
      try {
        const config = {
          headers: {
            "Content-Type": "application/json",
          },
        };
        const res = await axios.post("api/profile", formData, config);
        dispatch({
          type: GET_PROFILE,
          payload: res.data,
        });
        dispatch(
          setAlert(edit ? "Profile Updated" : "Profile created", "success")
        );
        if (!edit) {
          history.push("/dashboard");
        }
      } catch (err) {
        console.log(err);
        const errors = err.response.data.errors;
        console.log(errors);
        if (errors) {
          errors.forEach((error) => dispatch(setAlert(error.msg, "danger")));
        }
        dispatch({
          type: PROFILE_ERROR,
          payload: { msg: err.response.statusText, status: err.response.status },
        });
      }
    };

// add experiance
export const addExperience = (formData, history) => async (dispatch) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const res = await axios.put("api/profile/experience", formData, config);
    dispatch({
      type: UPDATE_PROFILE,
      payload: res.data,
    });
    dispatch(setAlert("Experience added", "success"));
    history.push("/dashboard");
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, "danger")));
    }
    dispatch({
      type: PROFILE_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Add Education

export const addEducation = (formData, history) => async (dispatch) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const res = await axios.put("api/profile/education", formData, config);
    dispatch({
      type: UPDATE_PROFILE,
      payload: res.data,
    });
    dispatch(setAlert("Education added", "success"));
    history.push("/dashboard");
  } catch (err) {
    console.log(err);
    const errors = err.response.data.errors;
    console.log(errors);
    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, "danger")));
    }
    dispatch({
      type: PROFILE_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// delete experience
export const deleteExperience = (id) => async (dispatch) => {
  try {
    const res = await axios.delete(`/api/profile/experience/${id}`);
    dispatch({
      type: UPDATE_PROFILE,
      payload: res.data,
    });
    dispatch(setAlert("Experience removed", "success"));
  } catch (err) {
    dispatch({
      type: PROFILE_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// delete education
export const deleteEducation = (id) => async (dispatch) => {
  try {
    const res = await axios.delete(`/api/profile/education/${id}`);
    dispatch({
      type: UPDATE_PROFILE,
      payload: res.data,
    });
    dispatch(setAlert("Education removed", "success"));
  } catch (err) {
    dispatch({
      type: PROFILE_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

//delete account profile
export const deleteAccount = () => async (dispatch) => {
  if (window.confirm("Are you sure? This canot be undone!")) {
    try {
      await axios.delete("/api/profile");
      dispatch({ type: CLEAR_PROFILE });
      dispatch({ type: ACCOUNT_DELETED });
      dispatch(setAlert("Your account has been permently deleted"));
    } catch (err) {
      dispatch({
        type: PROFILE_ERROR,
        payload: { msg: err.response.statusText, status: err.response.status },
      });
    }
  }
};

export const fetchAccountInfo = async () => {
  try {
    // Mengambil token dari local storage
    const token = localStorage.getItem('token');

    // Pastikan token ada sebelum melakukan fetch
    if (token) {
      const response = await axios.get('/api/users/getAccountInfo', {
        headers: {
          'Content-Type': 'application/json',
          'x-auth-token': token,
        },
      });

      // Mengembalikan data response jika request berhasil
      return response.data;
    }
  } catch (error) {
    console.error('Error fetching data:', error);
    // Mengembalikan null atau memberikan penanganan error sesuai kebutuhan
    return null;
  }
};

export const updateBusinessDetail = async (bodyRequest) => {
  try {
    const token = localStorage.getItem('token');

    if (token) {
      const response = await axios.post('/api/users/business/updateInformation', bodyRequest, {
        headers: {
          'Content-Type': 'application/json',
          'x-auth-token': token,
        },
      });

      return response.data;
    }
  } catch (error) {
    console.error('Error fetching data:', error);
    return null;
  }
};

export const updateIndividualDetail = async (bodyRequest) => {
  try {
    const token = localStorage.getItem('token');

    if (token) {
      const response = await axios.post('/api/users/individual/updateInformation', bodyRequest, {
        headers: {
          'Content-Type': 'application/json',
          'x-auth-token': token,
        },
      });

      return response.data;
    }
  } catch (error) {
    console.error('Error fetching data:', error);
    return null;
  }
};

export const updateIndividualBillingInformation = async (billingInformation) => {
  try {
    // Mengambil token dari local storage
    const token = localStorage.getItem('token');

    // Pastikan token ada sebelum melakukan fetch
    if (token) {
      const response = await axios.post('/api/users/individual/updateInformation', {
        billingInformation: billingInformation,
      }, {
        headers: {
          'Content-Type': 'application/json',
          'x-auth-token': token,
        },
      });


      // Mengembalikan data response jika request berhasil
      return response.data;
    }
  } catch (error) {
    console.error('Error fetching data:', error);
    // Mengembalikan null atau memberikan penanganan error sesuai kebutuhan
    return null;
  }
};

export const updatePaymentMethod = async (individualDetailId, paymentMethod) => {
  try {
    // Mengambil token dari local storage
    const token = localStorage.getItem('token');

    // Pastikan token ada sebelum melakukan fetch
    if (token) {
      const response = await axios.post('/api/users/individual/payment-method/' + individualDetailId, {
        paymentMethod: paymentMethod,
      }, {
        headers: {
          'Content-Type': 'application/json',
          'x-auth-token': token,
        },
      });


      // Mengembalikan data response jika request berhasil
      const res = {
        response_code: response.status,
        body: response.data
      };

      // Return the response object
      return res;
    }
  } catch (error) {
    console.error('Error fetching data:', error);
    // Mengembalikan null atau memberikan penanganan error sesuai kebutuhan
    return null;
  }
};

export const changeEmailCheckPassword = async (reqBody) => {
  try {
    const token = localStorage.getItem('token');

    if (token) {
      const response = await axios.post('/api/users/check-password', reqBody, {
        headers: {
          'Content-Type': 'application/json',
          'x-auth-token': token,
        },
      });

      return response.data;
    }
  } catch (error) {
    // console.error('Error fetching data:', error.response.data);

    return error.response.data;
  }
};

export const verifyToken = async (reqBody) => {
  try {
    const token = localStorage.getItem('token');

    if (token) {
      const response = await axios.post('/api/users/verify-token', reqBody, {
        headers: {
          'Content-Type': 'application/json',
          'x-auth-token': token,
        },
      });

      return response.data;
    }
  } catch (error) {
    console.error('Error fetching data:', error);

    return error.response.data;
  }
};

export const verifyNewEmail = async (reqBody) => {
  try {
    const token = localStorage.getItem('token');

    if (token) {
      const response = await axios.post('/api/users/change-email', reqBody, {
        headers: {
          'Content-Type': 'application/json',
          'x-auth-token': token,
        },
      });

      return response.data;
    }
  } catch (error) {
    console.error('Error fetching data:', error);

    return error.response.data;
  }
};

export const changeEmailVerification = async (reqBody) => {
  try {
    const response = await axios.post('/api/users/change-email/email-verification', reqBody, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return response.data;
  } catch (error) {
    console.error('Error fetching data:', error);
    console.log(error.data)

    return null;
  }
};

export const saveNewPassword = async (reqBody) => {
  try {
    const token = localStorage.getItem('token');

    if (token) {
      const response = await axios.post('/api/users/change-password', reqBody, {
        headers: {
          'Content-Type': 'application/json',
          'x-auth-token': token,
        },
      });

      return response.data;
    }
  } catch (error) {
    console.error('Error fetching data:', error);

    return null;
  }
};

export const resendEmailVerification = async (reqBody) => {
  try {
    const token = localStorage.getItem('token');

    if (token) {
      const response = await axios.post('/api/users/change-email/resend-verification', reqBody, {
        headers: {
          'Content-Type': 'application/json',
          'x-auth-token': token,
        },
      });

      return response.data;
    }
  } catch (error) {
    console.error('Error fetching data:', error);

    return error.response.data;
  }
};

export const revertChanges = async (reqBody) => {
  try {
    const response = await axios.post('/api/users/revert-changes', reqBody, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return response.data;
  } catch (error) {
    console.error('Error fetching data:', error);
    console.log(error.data)

    return null;
  }
};